/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Api
 * My ATS API
 * OpenAPI spec version: 0.1.0
 */
import * as zod from 'zod';


/**
 * @summary Get masked AI fallback provider configuration
 */
export const GetAIProviderChainResponse = zod.object({
  "enabled": zod.boolean(),
  "providers": zod.array(zod.object({
  "id": zod.enum(['google', 'hasaPoc', 'hasaDev']),
  "label": zod.string(),
  "baseUrl": zod.string(),
  "model": zod.string(),
  "configured": zod.boolean(),
  "keyMasked": zod.string()
}))
})


/**
 * @summary Atomically replace provider keys and enable or disable fallback chain
 */
export const updateAIProviderChainBodyGoogleKeyMax = 4096;

export const updateAIProviderChainBodyHasaPocKeyMax = 4096;

export const updateAIProviderChainBodyHasaDevKeyMax = 4096;



export const UpdateAIProviderChainBody = zod.object({
  "enabled": zod.boolean(),
  "googleKey": zod.string().max(updateAIProviderChainBodyGoogleKeyMax).optional().describe('Omit or leave blank to preserve the current key'),
  "hasaPocKey": zod.string().max(updateAIProviderChainBodyHasaPocKeyMax).optional(),
  "hasaDevKey": zod.string().max(updateAIProviderChainBodyHasaDevKeyMax).optional()
})

export const UpdateAIProviderChainResponse = zod.object({
  "enabled": zod.boolean(),
  "providers": zod.array(zod.object({
  "id": zod.enum(['google', 'hasaPoc', 'hasaDev']),
  "label": zod.string(),
  "baseUrl": zod.string(),
  "model": zod.string(),
  "configured": zod.boolean(),
  "keyMasked": zod.string()
}))
})


/**
 * @summary Health check
 */
export const HealthCheckResponse = zod.object({
  "status": zod.string()
})


/**
 * @summary Register a new user
 */
export const RegisterBody = zod.object({
  "email": zod.string(),
  "password": zod.string(),
  "name": zod.string()
})

export const RegisterResponse = zod.object({
  "id": zod.number(),
  "email": zod.string().nullable(),
  "name": zod.string(),
  "subscriptionStatus": zod.enum(['free', 'basic', 'premium']),
  "createdAt": zod.string()
})


/**
 * @summary Login with email and password
 */
export const LoginBody = zod.object({
  "email": zod.string(),
  "password": zod.string()
})

export const LoginResponse = zod.object({
  "id": zod.number(),
  "email": zod.string().nullable(),
  "name": zod.string(),
  "subscriptionStatus": zod.enum(['free', 'basic', 'premium']),
  "createdAt": zod.string()
})


/**
 * @summary Exchange a Toss authorization code for an application session
 */
export const LoginWithTossBody = zod.object({
  "authorizationCode": zod.string(),
  "referrer": zod.enum(['DEFAULT', 'SANDBOX'])
})

export const LoginWithTossResponse = zod.object({
  "sessionToken": zod.string(),
  "expiresAt": zod.coerce.date(),
  "user": zod.object({
  "id": zod.number(),
  "email": zod.string().nullable(),
  "name": zod.string(),
  "subscriptionStatus": zod.enum(['free', 'basic', 'premium']),
  "createdAt": zod.string()
})
})


/**
 * @summary Logout current user
 */
export const LogoutResponse = zod.object({
  "message": zod.string()
})


/**
 * @summary Get current user
 */
export const GetMeResponse = zod.object({
  "id": zod.number(),
  "email": zod.string().nullable(),
  "name": zod.string(),
  "subscriptionStatus": zod.enum(['free', 'basic', 'premium']),
  "createdAt": zod.string()
})


/**
 * @summary List available subscription plans
 */
export const ListSubscriptionPlansResponseItem = zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "price": zod.number(),
  "analysesPerMonth": zod.number(),
  "description": zod.string(),
  "features": zod.array(zod.string()).optional()
})
export const ListSubscriptionPlansResponse = zod.array(ListSubscriptionPlansResponseItem)


/**
 * @summary Get current user subscription status
 */
export const GetMySubscriptionResponse = zod.object({
  "status": zod.enum(['free', 'basic', 'premium', 'cancelled']),
  "planId": zod.string().nullable(),
  "analysesUsed": zod.number(),
  "analysesLimit": zod.number(),
  "expiresAt": zod.string().nullish()
})


/**
 * @summary Subscribe to a plan
 */
export const SubscribeBody = zod.object({
  "planId": zod.string()
})

export const SubscribeResponse = zod.object({
  "status": zod.enum(['free', 'basic', 'premium', 'cancelled']),
  "planId": zod.string().nullable(),
  "analysesUsed": zod.number(),
  "analysesLimit": zod.number(),
  "expiresAt": zod.string().nullish()
})


/**
 * @summary Cancel current subscription
 */
export const CancelSubscriptionResponse = zod.object({
  "message": zod.string()
})


/**
 * @summary Get the Apps in Toss analysis ticket balance and history
 */
export const GetAnalysisTicketSummaryResponse = zod.object({
  "monthlyUsed": zod.number(),
  "monthlyLimit": zod.number(),
  "monthlyRemaining": zod.number(),
  "ticketBalance": zod.number(),
  "history": zod.array(zod.object({
  "id": zod.string(),
  "type": zod.enum(['earned', 'used', 'expired']),
  "source": zod.string(),
  "amount": zod.number(),
  "occurredAt": zod.coerce.date(),
  "analysisId": zod.number().nullable()
}))
})


/**
 * @summary Get Apps in Toss analysis ticket history with cursor pagination
 */
export const getAnalysisTicketHistoryQueryLimitDefault = 20;
export const getAnalysisTicketHistoryQueryLimitMax = 50;



export const GetAnalysisTicketHistoryQueryParams = zod.object({
  "cursor": zod.coerce.string().optional(),
  "limit": zod.coerce.number().min(1).max(getAnalysisTicketHistoryQueryLimitMax).default(getAnalysisTicketHistoryQueryLimitDefault)
})

export const GetAnalysisTicketHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "type": zod.enum(['earned', 'used', 'expired']),
  "source": zod.string(),
  "amount": zod.number(),
  "occurredAt": zod.coerce.date(),
  "analysisId": zod.number().nullable()
})),
  "nextCursor": zod.string().nullable()
})


/**
 * @summary Grant one analysis ticket after a rewarded ad event
 */
export const GrantAnalysisTicketRewardBody = zod.object({
  "grantReference": zod.string(),
  "unitType": zod.string().optional(),
  "unitAmount": zod.number().optional()
})

export const GrantAnalysisTicketRewardResponse = zod.object({
  "granted": zod.boolean(),
  "summary": zod.object({
  "monthlyUsed": zod.number(),
  "monthlyLimit": zod.number(),
  "monthlyRemaining": zod.number(),
  "ticketBalance": zod.number(),
  "history": zod.array(zod.object({
  "id": zod.string(),
  "type": zod.enum(['earned', 'used', 'expired']),
  "source": zod.string(),
  "amount": zod.number(),
  "occurredAt": zod.coerce.date(),
  "analysisId": zod.number().nullable()
}))
})
})


/**
 * @summary 필터 조건으로 실제 provider 채용공고 검색
 */
export const FetchPostingsBody = zod.object({
  "careerLevel": zod.array(zod.string()).optional(),
  "educationLevel": zod.string().optional(),
  "recruitmentField": zod.array(zod.string()).optional()
})

export const FetchPostingsResponseItem = zod.object({
  "name": zod.string(),
  "siteUrl": zod.string().nullish(),
  "jobPostingUrl": zod.string().nullish(),
  "talentProfile": zod.string().nullish(),
  "jobDescription": zod.string().nullish(),
  "careerLevel": zod.array(zod.string()).nullish(),
  "educationLevel": zod.string().nullish(),
  "recruitmentField": zod.array(zod.string()).nullish()
})
export const FetchPostingsResponse = zod.array(FetchPostingsResponseItem)


/**
 * @summary Create a company posting search session
 */
export const createPostingSearchConditionsBodyRequestIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const createPostingSearchConditionsBodyResumeIdDefault = null;
export const createPostingSearchConditionsBodyResumeIdMax = 2147483647;

export const createPostingSearchConditionsBodyProvidersMax = 3;

export const createPostingSearchConditionsBodyOverridesTargetRolesValueItemMax = 200;

export const createPostingSearchConditionsBodyOverridesTargetRolesValueMax = 20;

export const createPostingSearchConditionsBodyOverridesKeywordsValueItemMax = 200;

export const createPostingSearchConditionsBodyOverridesKeywordsValueMax = 20;

export const createPostingSearchConditionsBodyOverridesExperienceValueRelatedMonthsMin = 0;
export const createPostingSearchConditionsBodyOverridesExperienceValueRelatedMonthsMax = 1200;

export const createPostingSearchConditionsBodyOverridesLocationsValueItemMax = 200;

export const createPostingSearchConditionsBodyOverridesLocationsValueMax = 20;

export const createPostingSearchConditionsBodyOverridesEmploymentTypesValueItemMax = 200;

export const createPostingSearchConditionsBodyOverridesEmploymentTypesValueMax = 20;

export const createPostingSearchConditionsBodyOverridesMinimumSalaryValueAmountMax = 1000000000000;

export const createPostingSearchConditionsBodyOverridesIndustriesValueItemMax = 200;

export const createPostingSearchConditionsBodyOverridesIndustriesValueMax = 20;



export const CreatePostingSearchConditionsBody = zod.object({
  "requestId": zod.string().regex(createPostingSearchConditionsBodyRequestIdRegExp),
  "resumeId": zod.number().min(1).max(createPostingSearchConditionsBodyResumeIdMax).nullish().default(createPostingSearchConditionsBodyResumeIdDefault),
  "providers": zod.array(zod.enum(['saramin', 'jobkorea', 'wanted'])).min(1).max(createPostingSearchConditionsBodyProvidersMax),
  "overrides": zod.object({
  "targetRoles": zod.object({
  "value": zod.array(zod.string().min(1).max(createPostingSearchConditionsBodyOverridesTargetRolesValueItemMax)).min(1).max(createPostingSearchConditionsBodyOverridesTargetRolesValueMax),
  "strength": zod.enum(['required', 'preferred'])
}).optional(),
  "keywords": zod.object({
  "value": zod.array(zod.string().min(1).max(createPostingSearchConditionsBodyOverridesKeywordsValueItemMax)).min(1).max(createPostingSearchConditionsBodyOverridesKeywordsValueMax),
  "strength": zod.enum(['required', 'preferred'])
}).optional(),
  "experience": zod.object({
  "value": zod.object({
  "mode": zod.enum(['entry', 'experienced', 'any']),
  "relatedMonths": zod.number().min(createPostingSearchConditionsBodyOverridesExperienceValueRelatedMonthsMin).max(createPostingSearchConditionsBodyOverridesExperienceValueRelatedMonthsMax).nullable(),
  "includeNoMatter": zod.boolean()
}),
  "strength": zod.enum(['required', 'preferred'])
}).optional(),
  "education": zod.object({
  "value": zod.object({
  "level": zod.enum(['high_school', 'college', 'university', 'master', 'doctor']),
  "completion": zod.enum(['graduated', 'expected', 'enrolled', 'unknown'])
}),
  "strength": zod.enum(['required', 'preferred'])
}).optional(),
  "locations": zod.object({
  "value": zod.array(zod.string().min(1).max(createPostingSearchConditionsBodyOverridesLocationsValueItemMax)).min(1).max(createPostingSearchConditionsBodyOverridesLocationsValueMax),
  "strength": zod.enum(['required', 'preferred'])
}).optional(),
  "employmentTypes": zod.object({
  "value": zod.array(zod.string().min(1).max(createPostingSearchConditionsBodyOverridesEmploymentTypesValueItemMax)).min(1).max(createPostingSearchConditionsBodyOverridesEmploymentTypesValueMax),
  "strength": zod.enum(['required', 'preferred'])
}).optional(),
  "minimumSalary": zod.object({
  "value": zod.object({
  "amount": zod.number().min(1).max(createPostingSearchConditionsBodyOverridesMinimumSalaryValueAmountMax),
  "currency": zod.enum(['KRW']),
  "period": zod.enum(['year']),
  "unit": zod.enum(['won'])
}),
  "strength": zod.enum(['required', 'preferred'])
}).optional(),
  "industries": zod.object({
  "value": zod.array(zod.string().min(1).max(createPostingSearchConditionsBodyOverridesIndustriesValueItemMax)).min(1).max(createPostingSearchConditionsBodyOverridesIndustriesValueMax),
  "strength": zod.enum(['required', 'preferred'])
}).optional(),
  "includePastIndustry": zod.boolean().optional()
}),
  "sort": zod.enum(['provider_default', 'latest'])
})

export const createPostingSearchConditionsResponseSearchIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const createPostingSearchConditionsResponseVersionMin = 0;

export const createPostingSearchConditionsResponsePlanResumeIdMax = 2147483647;

export const createPostingSearchConditionsResponsePlanTargetRolesValueItemMax = 200;

export const createPostingSearchConditionsResponsePlanTargetRolesValueMax = 20;

export const createPostingSearchConditionsResponsePlanKeywordsOneValueItemMax = 200;

export const createPostingSearchConditionsResponsePlanKeywordsOneValueMax = 20;

export const createPostingSearchConditionsResponsePlanExperienceOneValueRelatedMonthsMin = 0;
export const createPostingSearchConditionsResponsePlanExperienceOneValueRelatedMonthsMax = 1200;

export const createPostingSearchConditionsResponsePlanLocationsOneValueItemMax = 200;

export const createPostingSearchConditionsResponsePlanLocationsOneValueMax = 20;

export const createPostingSearchConditionsResponsePlanEmploymentTypesOneValueItemMax = 200;

export const createPostingSearchConditionsResponsePlanEmploymentTypesOneValueMax = 20;

export const createPostingSearchConditionsResponsePlanMinimumSalaryOneValueAmountMax = 1000000000000;

export const createPostingSearchConditionsResponsePlanIndustriesOneValueItemMax = 200;

export const createPostingSearchConditionsResponsePlanIndustriesOneValueMax = 20;



export const CreatePostingSearchConditionsResponse = zod.object({
  "searchId": zod.string().regex(createPostingSearchConditionsResponseSearchIdRegExp),
  "version": zod.number().min(createPostingSearchConditionsResponseVersionMin),
  "plan": zod.object({
  "schemaVersion": zod.literal(1),
  "source": zod.enum(['llm', 'explicit', 'deterministic']),
  "resumeId": zod.number().min(1).max(createPostingSearchConditionsResponsePlanResumeIdMax).nullable(),
  "resumeFingerprint": zod.string().nullable(),
  "targetRoles": zod.object({
  "value": zod.array(zod.string().min(1).max(createPostingSearchConditionsResponsePlanTargetRolesValueItemMax)).max(createPostingSearchConditionsResponsePlanTargetRolesValueMax),
  "strength": zod.enum(['required', 'preferred']),
  "evidence": zod.array(zod.object({
  "source": zod.enum(['user', 'career_analysis', 'resume']),
  "fieldPath": zod.string(),
  "excerpt": zod.string().optional()
}))
}),
  "keywords": zod.union([zod.object({
  "value": zod.array(zod.string().min(1).max(createPostingSearchConditionsResponsePlanKeywordsOneValueItemMax)).max(createPostingSearchConditionsResponsePlanKeywordsOneValueMax),
  "strength": zod.enum(['required', 'preferred']),
  "evidence": zod.array(zod.object({
  "source": zod.enum(['user', 'career_analysis', 'resume']),
  "fieldPath": zod.string(),
  "excerpt": zod.string().optional()
}))
}),zod.null()]),
  "experience": zod.union([zod.object({
  "value": zod.object({
  "mode": zod.enum(['entry', 'experienced', 'any']),
  "relatedMonths": zod.number().min(createPostingSearchConditionsResponsePlanExperienceOneValueRelatedMonthsMin).max(createPostingSearchConditionsResponsePlanExperienceOneValueRelatedMonthsMax).nullable(),
  "includeNoMatter": zod.boolean()
}),
  "strength": zod.enum(['required', 'preferred']),
  "evidence": zod.array(zod.object({
  "source": zod.enum(['user', 'career_analysis', 'resume']),
  "fieldPath": zod.string(),
  "excerpt": zod.string().optional()
}))
}),zod.null()]),
  "education": zod.union([zod.object({
  "value": zod.object({
  "level": zod.enum(['high_school', 'college', 'university', 'master', 'doctor']),
  "completion": zod.enum(['graduated', 'expected', 'enrolled', 'unknown'])
}),
  "strength": zod.enum(['required', 'preferred']),
  "evidence": zod.array(zod.object({
  "source": zod.enum(['user', 'career_analysis', 'resume']),
  "fieldPath": zod.string(),
  "excerpt": zod.string().optional()
}))
}),zod.null()]),
  "locations": zod.union([zod.object({
  "value": zod.array(zod.string().min(1).max(createPostingSearchConditionsResponsePlanLocationsOneValueItemMax)).max(createPostingSearchConditionsResponsePlanLocationsOneValueMax),
  "strength": zod.enum(['required', 'preferred']),
  "evidence": zod.array(zod.object({
  "source": zod.enum(['user', 'career_analysis', 'resume']),
  "fieldPath": zod.string(),
  "excerpt": zod.string().optional()
}))
}),zod.null()]),
  "employmentTypes": zod.union([zod.object({
  "value": zod.array(zod.string().min(1).max(createPostingSearchConditionsResponsePlanEmploymentTypesOneValueItemMax)).max(createPostingSearchConditionsResponsePlanEmploymentTypesOneValueMax),
  "strength": zod.enum(['required', 'preferred']),
  "evidence": zod.array(zod.object({
  "source": zod.enum(['user', 'career_analysis', 'resume']),
  "fieldPath": zod.string(),
  "excerpt": zod.string().optional()
}))
}),zod.null()]),
  "minimumSalary": zod.union([zod.object({
  "value": zod.object({
  "amount": zod.number().min(1).max(createPostingSearchConditionsResponsePlanMinimumSalaryOneValueAmountMax),
  "currency": zod.enum(['KRW']),
  "period": zod.enum(['year']),
  "unit": zod.enum(['won'])
}),
  "strength": zod.enum(['required', 'preferred']),
  "evidence": zod.array(zod.object({
  "source": zod.enum(['user', 'career_analysis', 'resume']),
  "fieldPath": zod.string(),
  "excerpt": zod.string().optional()
}))
}),zod.null()]),
  "industries": zod.union([zod.object({
  "value": zod.array(zod.string().min(1).max(createPostingSearchConditionsResponsePlanIndustriesOneValueItemMax)).max(createPostingSearchConditionsResponsePlanIndustriesOneValueMax),
  "strength": zod.enum(['required', 'preferred']),
  "evidence": zod.array(zod.object({
  "source": zod.enum(['user', 'career_analysis', 'resume']),
  "fieldPath": zod.string(),
  "excerpt": zod.string().optional()
}))
}),zod.null()]),
  "includePastIndustry": zod.boolean(),
  "sort": zod.enum(['provider_default', 'latest']),
  "catalogVersions": zod.record(zod.string(), zod.string()),
  "warnings": zod.array(zod.string())
}),
  "providerCapabilities": zod.record(zod.string(), zod.object({
  "id": zod.enum(['saramin', 'jobkorea', 'wanted']),
  "executable": zod.boolean(),
  "applied": zod.array(zod.string()),
  "unapplied": zod.array(zod.object({
  "field": zod.string(),
  "required": zod.boolean(),
  "reason": zod.enum(['unsupported', 'unverified_mapping', 'ambiguous', 'missing_evidence', 'no_catalog_match'])
})),
  "warnings": zod.array(zod.string())
})),
  "warnings": zod.array(zod.string()),
  "expiresAt": zod.coerce.date()
})


/**
 * @summary Fetch the next company posting batch
 */
export const fetchNextPostingSearchBatchPathSearchIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const FetchNextPostingSearchBatchParams = zod.object({
  "searchId": zod.coerce.string().regex(fetchNextPostingSearchBatchPathSearchIdRegExp)
})

export const fetchNextPostingSearchBatchBodyRequestIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const fetchNextPostingSearchBatchBodyExpectedVersionMin = 0;
export const fetchNextPostingSearchBatchBodyExpectedVersionMax = 2147483647;

export const fetchNextPostingSearchBatchBodyLimitMax = 20;



export const FetchNextPostingSearchBatchBody = zod.object({
  "requestId": zod.string().regex(fetchNextPostingSearchBatchBodyRequestIdRegExp),
  "expectedVersion": zod.number().min(fetchNextPostingSearchBatchBodyExpectedVersionMin).max(fetchNextPostingSearchBatchBodyExpectedVersionMax),
  "limit": zod.number().min(1).max(fetchNextPostingSearchBatchBodyLimitMax)
})

export const fetchNextPostingSearchBatchResponseSearchIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const fetchNextPostingSearchBatchResponseBatchIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const fetchNextPostingSearchBatchResponseVersionMin = 0;

export const fetchNextPostingSearchBatchResponsePostingsItemKeyMax = 512;

export const fetchNextPostingSearchBatchResponsePostingsItemJobPostingUrlRegExp = new RegExp('^https?:[/][/]');
export const fetchNextPostingSearchBatchResponsePostingsItemSourceSearchUrlRegExp = new RegExp('^https?:[/][/]');
export const fetchNextPostingSearchBatchResponsePostingsItemCompanyUrlRegExp = new RegExp('^https?:[/][/]');
export const fetchNextPostingSearchBatchResponseProviderStatusItemFetchedPagesMin = 0;

export const fetchNextPostingSearchBatchResponseProviderStatusItemPendingMin = 0;

export const fetchNextPostingSearchBatchResponseRetryAfterMsMin = 0;



export const FetchNextPostingSearchBatchResponse = zod.object({
  "searchId": zod.string().regex(fetchNextPostingSearchBatchResponseSearchIdRegExp),
  "batchId": zod.string().regex(fetchNextPostingSearchBatchResponseBatchIdRegExp),
  "version": zod.number().min(fetchNextPostingSearchBatchResponseVersionMin),
  "postings": zod.array(zod.object({
  "key": zod.string().min(1).max(fetchNextPostingSearchBatchResponsePostingsItemKeyMax),
  "source": zod.enum(['saramin', 'jobkorea', 'wanted']),
  "sourcePostingId": zod.string().nullable(),
  "companyName": zod.string().nullable(),
  "title": zod.string(),
  "jobPostingUrl": zod.string().regex(fetchNextPostingSearchBatchResponsePostingsItemJobPostingUrlRegExp),
  "sourceSearchUrl": zod.string().regex(fetchNextPostingSearchBatchResponsePostingsItemSourceSearchUrlRegExp),
  "companyUrl": zod.string().regex(fetchNextPostingSearchBatchResponsePostingsItemCompanyUrlRegExp).nullable(),
  "locationText": zod.string().nullable(),
  "careerText": zod.string().nullable(),
  "educationText": zod.string().nullable(),
  "employmentTypeText": zod.string().nullable(),
  "salaryText": zod.string().nullable(),
  "deadlineText": zod.string().nullable(),
  "summary": zod.string().nullable(),
  "jobDescription": zod.string().nullable(),
  "fetchedAt": zod.coerce.date(),
  "detailStatus": zod.enum(['not_requested', 'ok', 'blocked', 'unavailable', 'empty'])
})),
  "providerStatus": zod.array(zod.object({
  "provider": zod.enum(['saramin', 'jobkorea', 'wanted']),
  "exhausted": zod.boolean(),
  "failure": zod.union([zod.enum(['blocked', 'rate_limited', 'timeout', 'upstream_error', 'parse_error', 'unsupported_filters', 'not_configured']),zod.null()]),
  "retryAt": zod.union([zod.coerce.date(),zod.null()]),
  "fetchedPages": zod.number().min(fetchNextPostingSearchBatchResponseProviderStatusItemFetchedPagesMin),
  "pending": zod.number().min(fetchNextPostingSearchBatchResponseProviderStatusItemPendingMin)
})),
  "completion": zod.enum(['more', 'exhausted', 'interrupted']),
  "isLast": zod.boolean(),
  "retryAfterMs": zod.number().min(fetchNextPostingSearchBatchResponseRetryAfterMsMin).nullable(),
  "warnings": zod.array(zod.string())
})


/**
 * @summary Save delivered company posting candidates
 */
export const savePostingSearchCandidatesPathSearchIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const SavePostingSearchCandidatesParams = zod.object({
  "searchId": zod.coerce.string().regex(savePostingSearchCandidatesPathSearchIdRegExp)
})

export const savePostingSearchCandidatesBodyCandidateKeysItemMax = 512;

export const savePostingSearchCandidatesBodyCandidateKeysMax = 20;



export const SavePostingSearchCandidatesBody = zod.object({
  "candidateKeys": zod.array(zod.string().min(1).max(savePostingSearchCandidatesBodyCandidateKeysItemMax)).min(1).max(savePostingSearchCandidatesBodyCandidateKeysMax)
})

export const savePostingSearchCandidatesResponseCreatedItemCandidateKeyMax = 512;


export const savePostingSearchCandidatesResponseExistingItemCandidateKeyMax = 512;


export const savePostingSearchCandidatesResponseRejectedItemCandidateKeyMax = 512;



export const SavePostingSearchCandidatesResponse = zod.object({
  "created": zod.array(zod.object({
  "candidateKey": zod.string().min(1).max(savePostingSearchCandidatesResponseCreatedItemCandidateKeyMax),
  "companyId": zod.number().min(1)
})),
  "existing": zod.array(zod.object({
  "candidateKey": zod.string().min(1).max(savePostingSearchCandidatesResponseExistingItemCandidateKeyMax),
  "companyId": zod.number().min(1)
})),
  "rejected": zod.array(zod.object({
  "candidateKey": zod.string().min(1).max(savePostingSearchCandidatesResponseRejectedItemCandidateKeyMax),
  "code": zod.string()
}))
})


/**
 * @summary Fetch detail for a delivered company posting candidate
 */
export const fetchPostingSearchDetailPathSearchIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const FetchPostingSearchDetailParams = zod.object({
  "searchId": zod.coerce.string().regex(fetchPostingSearchDetailPathSearchIdRegExp)
})

export const fetchPostingSearchDetailBodyCandidateKeyMax = 512;



export const FetchPostingSearchDetailBody = zod.object({
  "candidateKey": zod.string().min(1).max(fetchPostingSearchDetailBodyCandidateKeyMax)
})

export const fetchPostingSearchDetailResponseSearchIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const fetchPostingSearchDetailResponseCandidateKeyMax = 512;

export const fetchPostingSearchDetailResponseVersionMin = 0;

export const fetchPostingSearchDetailResponsePostingKeyMax = 512;

export const fetchPostingSearchDetailResponsePostingJobPostingUrlRegExp = new RegExp('^https?:[/][/]');
export const fetchPostingSearchDetailResponsePostingSourceSearchUrlRegExp = new RegExp('^https?:[/][/]');
export const fetchPostingSearchDetailResponsePostingCompanyUrlRegExp = new RegExp('^https?:[/][/]');


export const FetchPostingSearchDetailResponse = zod.object({
  "searchId": zod.string().regex(fetchPostingSearchDetailResponseSearchIdRegExp),
  "candidateKey": zod.string().min(1).max(fetchPostingSearchDetailResponseCandidateKeyMax),
  "version": zod.number().min(fetchPostingSearchDetailResponseVersionMin),
  "posting": zod.object({
  "key": zod.string().min(1).max(fetchPostingSearchDetailResponsePostingKeyMax),
  "source": zod.enum(['saramin', 'jobkorea', 'wanted']),
  "sourcePostingId": zod.string().nullable(),
  "companyName": zod.string().nullable(),
  "title": zod.string(),
  "jobPostingUrl": zod.string().regex(fetchPostingSearchDetailResponsePostingJobPostingUrlRegExp),
  "sourceSearchUrl": zod.string().regex(fetchPostingSearchDetailResponsePostingSourceSearchUrlRegExp),
  "companyUrl": zod.string().regex(fetchPostingSearchDetailResponsePostingCompanyUrlRegExp).nullable(),
  "locationText": zod.string().nullable(),
  "careerText": zod.string().nullable(),
  "educationText": zod.string().nullable(),
  "employmentTypeText": zod.string().nullable(),
  "salaryText": zod.string().nullable(),
  "deadlineText": zod.string().nullable(),
  "summary": zod.string().nullable(),
  "jobDescription": zod.string().nullable(),
  "fetchedAt": zod.coerce.date(),
  "detailStatus": zod.enum(['not_requested', 'ok', 'blocked', 'unavailable', 'empty'])
})
})


/**
 * @summary 이력서 기반으로 회사 추천 (isRecommended 갱신)
 */
export const RecommendCompaniesBody = zod.object({
  "resumeId": zod.number()
})

export const RecommendCompaniesResponseItem = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "name": zod.string(),
  "siteUrl": zod.string().nullish(),
  "jobPostingUrl": zod.string().nullish(),
  "talentProfile": zod.string().nullish(),
  "jobDescription": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "careerLevel": zod.array(zod.string()).nullish().describe('경력구분 (신입·1년이내·3년이내)'),
  "educationLevel": zod.string().nullish().describe('학력 (전문대·대학교·석사)'),
  "recruitmentField": zod.array(zod.string()).nullish().describe('모집분야 (개발·기획·디자인·영업·품질관리·테스터·기타)'),
  "isRecommended": zod.boolean(),
  "syncedAt": zod.string(),
  "createdAt": zod.string()
})
export const RecommendCompaniesResponse = zod.array(RecommendCompaniesResponseItem)


/**
 * @summary Queue company recommendations for a pinned resume revision and company snapshot
 */
export const createCompanyRecommendationTaskHeaderIdempotencyKeyMax = 255;



export const CreateCompanyRecommendationTaskHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(createCompanyRecommendationTaskHeaderIdempotencyKeyMax)
})




export const CreateCompanyRecommendationTaskBody = zod.object({
  "resumeId": zod.number().min(1)
})

export const createCompanyRecommendationTaskResponseTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const CreateCompanyRecommendationTaskResponse = zod.object({
  "taskId": zod.string().regex(createCompanyRecommendationTaskResponseTaskIdRegExp),
  "feature": zod.enum(['resume-review', 'resume-upload', 'career-analysis', 'resume-spellcheck', 'interview-questions', 'interview-evaluation', 'cover-letter-prompts', 'cover-letter-audio', 'company-recommendation', 'job-posting-search', 'job-posting-import']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "subjectType": zod.string().nullable(),
  "subjectId": zod.string().nullable()
})


/**
 * @summary Queue a durable company posting search
 */
export const createJobPostingSearchTaskHeaderIdempotencyKeyMax = 255;



export const CreateJobPostingSearchTaskHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(createJobPostingSearchTaskHeaderIdempotencyKeyMax)
})


export const createJobPostingSearchTaskBodyFiltersCareerLevelItemMax = 100;

export const createJobPostingSearchTaskBodyFiltersCareerLevelMax = 20;

export const createJobPostingSearchTaskBodyFiltersEducationLevelMax = 100;

export const createJobPostingSearchTaskBodyFiltersRecruitmentFieldItemMax = 200;

export const createJobPostingSearchTaskBodyFiltersRecruitmentFieldMax = 20;

export const createJobPostingSearchTaskBodySearchRequestIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const CreateJobPostingSearchTaskBody = zod.object({
  "resumeId": zod.number().min(1).nullable(),
  "filters": zod.object({
  "careerLevel": zod.array(zod.string().min(1).max(createJobPostingSearchTaskBodyFiltersCareerLevelItemMax)).max(createJobPostingSearchTaskBodyFiltersCareerLevelMax),
  "educationLevel": zod.string().max(createJobPostingSearchTaskBodyFiltersEducationLevelMax).nullable(),
  "recruitmentField": zod.array(zod.string().min(1).max(createJobPostingSearchTaskBodyFiltersRecruitmentFieldItemMax)).max(createJobPostingSearchTaskBodyFiltersRecruitmentFieldMax)
}),
  "searchRequestId": zod.string().regex(createJobPostingSearchTaskBodySearchRequestIdRegExp)
})

export const createJobPostingSearchTaskResponseTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const CreateJobPostingSearchTaskResponse = zod.object({
  "taskId": zod.string().regex(createJobPostingSearchTaskResponseTaskIdRegExp),
  "feature": zod.enum(['resume-review', 'resume-upload', 'career-analysis', 'resume-spellcheck', 'interview-questions', 'interview-evaluation', 'cover-letter-prompts', 'cover-letter-audio', 'company-recommendation', 'job-posting-search', 'job-posting-import']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "subjectType": zod.string().nullable(),
  "subjectId": zod.string().nullable()
})


/**
 * @summary Queue SSRF-safe posting HTML/detail/OCR import
 */
export const createJobPostingImportTaskHeaderIdempotencyKeyMax = 255;



export const CreateJobPostingImportTaskHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(createJobPostingImportTaskHeaderIdempotencyKeyMax)
})


export const createJobPostingImportTaskBodyUrlMax = 2048;



export const CreateJobPostingImportTaskBody = zod.object({
  "companyId": zod.number().min(1).nullable(),
  "url": zod.string().max(createJobPostingImportTaskBodyUrlMax)
})

export const createJobPostingImportTaskResponseTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const CreateJobPostingImportTaskResponse = zod.object({
  "taskId": zod.string().regex(createJobPostingImportTaskResponseTaskIdRegExp),
  "feature": zod.enum(['resume-review', 'resume-upload', 'career-analysis', 'resume-spellcheck', 'interview-questions', 'interview-evaluation', 'cover-letter-prompts', 'cover-letter-audio', 'company-recommendation', 'job-posting-search', 'job-posting-import']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "subjectType": zod.string().nullable(),
  "subjectId": zod.string().nullable()
})


/**
 * @summary List all companies the user has added
 */
export const ListCompaniesResponseItem = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "name": zod.string(),
  "siteUrl": zod.string().nullish(),
  "jobPostingUrl": zod.string().nullish(),
  "talentProfile": zod.string().nullish(),
  "jobDescription": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "careerLevel": zod.array(zod.string()).nullish().describe('경력구분 (신입·1년이내·3년이내)'),
  "educationLevel": zod.string().nullish().describe('학력 (전문대·대학교·석사)'),
  "recruitmentField": zod.array(zod.string()).nullish().describe('모집분야 (개발·기획·디자인·영업·품질관리·테스터·기타)'),
  "isRecommended": zod.boolean(),
  "syncedAt": zod.string(),
  "createdAt": zod.string()
})
export const ListCompaniesResponse = zod.array(ListCompaniesResponseItem)


/**
 * @summary Add a company profile
 */
export const CreateCompanyBody = zod.object({
  "name": zod.string(),
  "siteUrl": zod.string().optional(),
  "jobPostingUrl": zod.string().optional(),
  "talentProfile": zod.string().optional(),
  "jobDescription": zod.string().optional(),
  "notes": zod.string().optional(),
  "careerLevel": zod.array(zod.string()).optional(),
  "educationLevel": zod.string().optional(),
  "recruitmentField": zod.array(zod.string()).optional()
})

export const CreateCompanyResponse = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "name": zod.string(),
  "siteUrl": zod.string().nullish(),
  "jobPostingUrl": zod.string().nullish(),
  "talentProfile": zod.string().nullish(),
  "jobDescription": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "careerLevel": zod.array(zod.string()).nullish().describe('경력구분 (신입·1년이내·3년이내)'),
  "educationLevel": zod.string().nullish().describe('학력 (전문대·대학교·석사)'),
  "recruitmentField": zod.array(zod.string()).nullish().describe('모집분야 (개발·기획·디자인·영업·품질관리·테스터·기타)'),
  "isRecommended": zod.boolean(),
  "syncedAt": zod.string(),
  "createdAt": zod.string()
})


/**
 * @summary Get a company profile
 */
export const GetCompanyParams = zod.object({
  "id": zod.coerce.number()
})

export const GetCompanyResponse = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "name": zod.string(),
  "siteUrl": zod.string().nullish(),
  "jobPostingUrl": zod.string().nullish(),
  "talentProfile": zod.string().nullish(),
  "jobDescription": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "careerLevel": zod.array(zod.string()).nullish().describe('경력구분 (신입·1년이내·3년이내)'),
  "educationLevel": zod.string().nullish().describe('학력 (전문대·대학교·석사)'),
  "recruitmentField": zod.array(zod.string()).nullish().describe('모집분야 (개발·기획·디자인·영업·품질관리·테스터·기타)'),
  "isRecommended": zod.boolean(),
  "syncedAt": zod.string(),
  "createdAt": zod.string()
})


/**
 * @summary Update a company profile
 */
export const UpdateCompanyParams = zod.object({
  "id": zod.coerce.number()
})

export const UpdateCompanyBody = zod.object({
  "name": zod.string().optional(),
  "siteUrl": zod.string().optional(),
  "jobPostingUrl": zod.string().optional(),
  "talentProfile": zod.string().optional(),
  "jobDescription": zod.string().optional(),
  "notes": zod.string().optional(),
  "careerLevel": zod.array(zod.string()).optional(),
  "educationLevel": zod.string().optional(),
  "recruitmentField": zod.array(zod.string()).optional()
})

export const UpdateCompanyResponse = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "name": zod.string(),
  "siteUrl": zod.string().nullish(),
  "jobPostingUrl": zod.string().nullish(),
  "talentProfile": zod.string().nullish(),
  "jobDescription": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "careerLevel": zod.array(zod.string()).nullish().describe('경력구분 (신입·1년이내·3년이내)'),
  "educationLevel": zod.string().nullish().describe('학력 (전문대·대학교·석사)'),
  "recruitmentField": zod.array(zod.string()).nullish().describe('모집분야 (개발·기획·디자인·영업·품질관리·테스터·기타)'),
  "isRecommended": zod.boolean(),
  "syncedAt": zod.string(),
  "createdAt": zod.string()
})


/**
 * @summary Delete a company profile
 */
export const DeleteCompanyParams = zod.object({
  "id": zod.coerce.number()
})

export const DeleteCompanyResponse = zod.void()


/**
 * @summary List all resumes of the user
 */
export const listResumesResponseRevisionIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const ListResumesResponseItem = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "title": zod.string(),
  "revisionId": zod.string().regex(listResumesResponseRevisionIdRegExp),
  "content": zod.string().nullish(),
  "coverLetter": zod.string().nullish(),
  "desiredSalary": zod.number().nullish(),
  "photoUrl": zod.string().nullish(),
  "fileUrl": zod.string().nullish(),
  "createdAt": zod.string(),
  "updatedAt": zod.string()
})
export const ListResumesResponse = zod.array(ListResumesResponseItem)


/**
 * @summary Create a resume with JSON body
 */
export const CreateResumeBody = zod.object({
  "title": zod.string(),
  "content": zod.string().optional(),
  "coverLetter": zod.string().optional(),
  "desiredSalary": zod.number().optional(),
  "photoUrl": zod.string().optional(),
  "fileUrl": zod.string().optional()
})

export const createResumeResponseRevisionIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const CreateResumeResponse = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "title": zod.string(),
  "revisionId": zod.string().regex(createResumeResponseRevisionIdRegExp),
  "content": zod.string().nullish(),
  "coverLetter": zod.string().nullish(),
  "desiredSalary": zod.number().nullish(),
  "photoUrl": zod.string().nullish(),
  "fileUrl": zod.string().nullish(),
  "createdAt": zod.string(),
  "updatedAt": zod.string()
})


/**
 * @summary AI 오탈자·맞춤법 검사
 */
export const SpellcheckResumeParams = zod.object({
  "id": zod.coerce.number()
})

export const SpellcheckResumeBody = zod.object({
  "content": zod.string().optional(),
  "coverLetter": zod.string().optional()
})

export const SpellcheckResumeResponse = zod.object({
  "corrections": zod.array(zod.object({
  "field": zod.string(),
  "original": zod.string(),
  "corrected": zod.string(),
  "reason": zod.string()
})),
  "contentCorrected": zod.string(),
  "coverLetterCorrected": zod.string()
})


/**
 * @summary Queue a spellcheck for the persisted resume revision
 */



export const CreateResumeSpellcheckTaskParams = zod.object({
  "id": zod.coerce.number().min(1)
})

export const createResumeSpellcheckTaskHeaderIdempotencyKeyMax = 255;



export const CreateResumeSpellcheckTaskHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(createResumeSpellcheckTaskHeaderIdempotencyKeyMax)
})

export const createResumeSpellcheckTaskResponseTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const CreateResumeSpellcheckTaskResponse = zod.object({
  "taskId": zod.string().regex(createResumeSpellcheckTaskResponseTaskIdRegExp),
  "feature": zod.enum(['resume-review', 'resume-upload', 'career-analysis', 'resume-spellcheck', 'interview-questions', 'interview-evaluation', 'cover-letter-prompts', 'cover-letter-audio', 'company-recommendation', 'job-posting-search', 'job-posting-import']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "subjectType": zod.string().nullable(),
  "subjectId": zod.string().nullable()
})


/**
 * @summary Queue career analysis for the latest resume revision
 */



export const CreateCareerAnalysisTaskParams = zod.object({
  "id": zod.coerce.number().min(1)
})

export const createCareerAnalysisTaskHeaderIdempotencyKeyMax = 255;



export const CreateCareerAnalysisTaskHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(createCareerAnalysisTaskHeaderIdempotencyKeyMax).optional()
})

export const createCareerAnalysisTaskResponseTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const CreateCareerAnalysisTaskResponse = zod.object({
  "taskId": zod.string().regex(createCareerAnalysisTaskResponseTaskIdRegExp),
  "feature": zod.enum(['resume-review', 'resume-upload', 'career-analysis', 'resume-spellcheck', 'interview-questions', 'interview-evaluation', 'cover-letter-prompts', 'cover-letter-audio', 'company-recommendation', 'job-posting-search', 'job-posting-import']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "subjectType": zod.string().nullable(),
  "subjectId": zod.string().nullable()
})


/**
 * @summary Persist a resume upload and queue extraction
 */
export const createResumeUploadTaskHeaderIdempotencyKeyMax = 255;



export const CreateResumeUploadTaskHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(createResumeUploadTaskHeaderIdempotencyKeyMax)
})

export const createResumeUploadTaskBodyTitleMax = 255;



export const CreateResumeUploadTaskBody = zod.object({
  "file": zod.instanceof(File),
  "title": zod.string().max(createResumeUploadTaskBodyTitleMax).optional()
})

export const createResumeUploadTaskResponseTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const CreateResumeUploadTaskResponse = zod.object({
  "taskId": zod.string().regex(createResumeUploadTaskResponseTaskIdRegExp),
  "feature": zod.enum(['resume-review', 'resume-upload', 'career-analysis', 'resume-spellcheck', 'interview-questions', 'interview-evaluation', 'cover-letter-prompts', 'cover-letter-audio', 'company-recommendation', 'job-posting-search', 'job-posting-import']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "subjectType": zod.string().nullable(),
  "subjectId": zod.string().nullable()
})


/**
 * @summary Get a resume
 */
export const GetResumeParams = zod.object({
  "id": zod.coerce.number()
})

export const getResumeResponseRevisionIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const GetResumeResponse = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "title": zod.string(),
  "revisionId": zod.string().regex(getResumeResponseRevisionIdRegExp),
  "content": zod.string().nullish(),
  "coverLetter": zod.string().nullish(),
  "desiredSalary": zod.number().nullish(),
  "photoUrl": zod.string().nullish(),
  "fileUrl": zod.string().nullish(),
  "createdAt": zod.string(),
  "updatedAt": zod.string()
})


/**
 * @summary Update a resume
 */
export const UpdateResumeParams = zod.object({
  "id": zod.coerce.number()
})

export const UpdateResumeBody = zod.object({
  "title": zod.string().optional(),
  "content": zod.string().optional(),
  "coverLetter": zod.string().optional(),
  "desiredSalary": zod.number().optional(),
  "photoUrl": zod.string().optional(),
  "fileUrl": zod.string().optional()
})

export const updateResumeResponseRevisionIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const UpdateResumeResponse = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "title": zod.string(),
  "revisionId": zod.string().regex(updateResumeResponseRevisionIdRegExp),
  "content": zod.string().nullish(),
  "coverLetter": zod.string().nullish(),
  "desiredSalary": zod.number().nullish(),
  "photoUrl": zod.string().nullish(),
  "fileUrl": zod.string().nullish(),
  "createdAt": zod.string(),
  "updatedAt": zod.string()
})


/**
 * @summary Delete a resume
 */
export const DeleteResumeParams = zod.object({
  "id": zod.coerce.number()
})

export const DeleteResumeResponse = zod.void()


/**
 * @summary Generate a cover letter from an audio recording
 */
export const GenerateCoverLetterBody = zod.object({
  "audio": zod.instanceof(File)
})

export const GenerateCoverLetterResponse = zod.object({
  "transcript": zod.string(),
  "coverLetter": zod.string()
})


/**
 * @summary Generate guided recording prompts from a resume
 */



export const GenerateGuidedPromptsBody = zod.object({
  "resumeId": zod.number().min(1)
})

export const GenerateGuidedPromptsResponse = zod.object({
  "prompts": zod.array(zod.string()),
  "usedFallback": zod.boolean()
})


/**
 * @summary Queue guided recording prompt generation
 */
export const createGuidedPromptsTaskHeaderIdempotencyKeyMax = 255;



export const CreateGuidedPromptsTaskHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(createGuidedPromptsTaskHeaderIdempotencyKeyMax)
})




export const CreateGuidedPromptsTaskBody = zod.object({
  "resumeId": zod.number().min(1)
})

export const createGuidedPromptsTaskResponseTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const CreateGuidedPromptsTaskResponse = zod.object({
  "taskId": zod.string().regex(createGuidedPromptsTaskResponseTaskIdRegExp),
  "feature": zod.enum(['resume-review', 'resume-upload', 'career-analysis', 'resume-spellcheck', 'interview-questions', 'interview-evaluation', 'cover-letter-prompts', 'cover-letter-audio', 'company-recommendation', 'job-posting-search', 'job-posting-import']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "subjectType": zod.string().nullable(),
  "subjectId": zod.string().nullable()
})


/**
 * @summary Persist audio and queue cover letter generation
 */
export const createCoverLetterAudioTaskHeaderIdempotencyKeyMax = 255;



export const CreateCoverLetterAudioTaskHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(createCoverLetterAudioTaskHeaderIdempotencyKeyMax)
})

export const CreateCoverLetterAudioTaskBody = zod.object({
  "audio": zod.instanceof(File)
})

export const createCoverLetterAudioTaskResponseTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const CreateCoverLetterAudioTaskResponse = zod.object({
  "taskId": zod.string().regex(createCoverLetterAudioTaskResponseTaskIdRegExp),
  "feature": zod.enum(['resume-review', 'resume-upload', 'career-analysis', 'resume-spellcheck', 'interview-questions', 'interview-evaluation', 'cover-letter-prompts', 'cover-letter-audio', 'company-recommendation', 'job-posting-search', 'job-posting-import']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "subjectType": zod.string().nullable(),
  "subjectId": zod.string().nullable()
})


/**
 * @summary List all analyses for the user
 */
export const ListAnalysesResponseItem = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "resumeId": zod.number(),
  "companyId": zod.number(),
  "status": zod.enum(['pending', 'processing', 'completed', 'failed']),
  "overallResult": zod.enum(['pass', 'fail', 'null']).nullish(),
  "errorMessage": zod.string().nullish(),
  "overallScore": zod.number().nullish(),
  "aiWritingScore": zod.number().nullish(),
  "aiWritingFeedback": zod.string().nullish(),
  "languageScore": zod.number().nullish(),
  "languageFeedback": zod.string().nullish(),
  "jobMatchScore": zod.number().nullish(),
  "jobMatchFeedback": zod.string().nullish(),
  "improvementSuggestions": zod.string().nullish(),
  "urlAnalysisResult": zod.string().nullish(),
  "richAnalysisResult": zod.string().nullish(),
  "resumeTitle": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "createdAt": zod.string(),
  "completedAt": zod.string().nullish()
})
export const ListAnalysesResponse = zod.array(ListAnalysesResponseItem)


/**
 * @summary Start an AI analysis for a resume + company
 */
export const CreateAnalysisBody = zod.object({
  "resumeId": zod.number(),
  "companyId": zod.number(),
  "allowTicket": zod.boolean().optional()
})

export const CreateAnalysisResponse = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "resumeId": zod.number(),
  "companyId": zod.number(),
  "status": zod.enum(['pending', 'processing', 'completed', 'failed']),
  "overallResult": zod.enum(['pass', 'fail', 'null']).nullish(),
  "errorMessage": zod.string().nullish(),
  "overallScore": zod.number().nullish(),
  "aiWritingScore": zod.number().nullish(),
  "aiWritingFeedback": zod.string().nullish(),
  "languageScore": zod.number().nullish(),
  "languageFeedback": zod.string().nullish(),
  "jobMatchScore": zod.number().nullish(),
  "jobMatchFeedback": zod.string().nullish(),
  "improvementSuggestions": zod.string().nullish(),
  "urlAnalysisResult": zod.string().nullish(),
  "richAnalysisResult": zod.string().nullish(),
  "resumeTitle": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "createdAt": zod.string(),
  "completedAt": zod.string().nullish()
})


/**
 * @summary Get an analysis result
 */
export const GetAnalysisParams = zod.object({
  "id": zod.coerce.number()
})

export const GetAnalysisResponse = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "resumeId": zod.number(),
  "companyId": zod.number(),
  "status": zod.enum(['pending', 'processing', 'completed', 'failed']),
  "overallResult": zod.enum(['pass', 'fail', 'null']).nullish(),
  "errorMessage": zod.string().nullish(),
  "overallScore": zod.number().nullish(),
  "aiWritingScore": zod.number().nullish(),
  "aiWritingFeedback": zod.string().nullish(),
  "languageScore": zod.number().nullish(),
  "languageFeedback": zod.string().nullish(),
  "jobMatchScore": zod.number().nullish(),
  "jobMatchFeedback": zod.string().nullish(),
  "improvementSuggestions": zod.string().nullish(),
  "urlAnalysisResult": zod.string().nullish(),
  "richAnalysisResult": zod.string().nullish(),
  "resumeTitle": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "createdAt": zod.string(),
  "completedAt": zod.string().nullish()
})


/**
 * @summary Atomically consume access and queue an AI analysis
 */
export const createAnalysisTaskHeaderIdempotencyKeyMax = 255;



export const CreateAnalysisTaskHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(createAnalysisTaskHeaderIdempotencyKeyMax)
})

export const CreateAnalysisTaskBody = zod.object({
  "resumeId": zod.number(),
  "companyId": zod.number(),
  "allowTicket": zod.boolean().optional()
})

export const createAnalysisTaskResponseTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const CreateAnalysisTaskResponse = zod.object({
  "taskId": zod.string().regex(createAnalysisTaskResponseTaskIdRegExp),
  "feature": zod.enum(['resume-review', 'resume-upload', 'career-analysis', 'resume-spellcheck', 'interview-questions', 'interview-evaluation', 'cover-letter-prompts', 'cover-letter-audio', 'company-recommendation', 'job-posting-search', 'job-posting-import']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "subjectType": zod.string().nullable(),
  "subjectId": zod.string().nullable()
})


/**
 * @summary Queue a single uncharged retry for a failed analysis
 */



export const RetryAnalysisTaskParams = zod.object({
  "id": zod.coerce.number().min(1)
})

export const retryAnalysisTaskHeaderIdempotencyKeyMax = 255;



export const RetryAnalysisTaskHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(retryAnalysisTaskHeaderIdempotencyKeyMax)
})

export const retryAnalysisTaskResponseTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const RetryAnalysisTaskResponse = zod.object({
  "taskId": zod.string().regex(retryAnalysisTaskResponseTaskIdRegExp),
  "feature": zod.enum(['resume-review', 'resume-upload', 'career-analysis', 'resume-spellcheck', 'interview-questions', 'interview-evaluation', 'cover-letter-prompts', 'cover-letter-audio', 'company-recommendation', 'job-posting-search', 'job-posting-import']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "subjectType": zod.string().nullable(),
  "subjectId": zod.string().nullable()
})


/**
 * @summary Retry a failed analysis with the same resume and company
 */
export const RetryAnalysisParams = zod.object({
  "id": zod.coerce.number()
})

export const RetryAnalysisResponse = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "resumeId": zod.number(),
  "companyId": zod.number(),
  "status": zod.enum(['pending', 'processing', 'completed', 'failed']),
  "overallResult": zod.enum(['pass', 'fail', 'null']).nullish(),
  "errorMessage": zod.string().nullish(),
  "overallScore": zod.number().nullish(),
  "aiWritingScore": zod.number().nullish(),
  "aiWritingFeedback": zod.string().nullish(),
  "languageScore": zod.number().nullish(),
  "languageFeedback": zod.string().nullish(),
  "jobMatchScore": zod.number().nullish(),
  "jobMatchFeedback": zod.string().nullish(),
  "improvementSuggestions": zod.string().nullish(),
  "urlAnalysisResult": zod.string().nullish(),
  "richAnalysisResult": zod.string().nullish(),
  "resumeTitle": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "createdAt": zod.string(),
  "completedAt": zod.string().nullish()
})


/**
 * @summary List all interview sessions for the user
 */
export const ListInterviewsResponseItem = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "resumeId": zod.number(),
  "companyId": zod.number(),
  "status": zod.enum(['pending', 'questions_generated', 'answers_submitted', 'evaluated']),
  "questions": zod.array(zod.object({
  "id": zod.number(),
  "question": zod.string(),
  "order": zod.number(),
  "answer": zod.string().nullish(),
  "feedback": zod.string().nullish(),
  "score": zod.number().nullish()
})).optional(),
  "overallScore": zod.number().nullish(),
  "overallFeedback": zod.string().nullish(),
  "resumeTitle": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "createdAt": zod.string(),
  "evaluatedAt": zod.string().nullish()
})
export const ListInterviewsResponse = zod.array(ListInterviewsResponseItem)


/**
 * @summary Generate interview questions for a resume + company
 */
export const CreateInterviewBody = zod.object({
  "resumeId": zod.number(),
  "companyId": zod.number()
})

export const CreateInterviewResponse = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "resumeId": zod.number(),
  "companyId": zod.number(),
  "status": zod.enum(['pending', 'questions_generated', 'answers_submitted', 'evaluated']),
  "questions": zod.array(zod.object({
  "id": zod.number(),
  "question": zod.string(),
  "order": zod.number(),
  "answer": zod.string().nullish(),
  "feedback": zod.string().nullish(),
  "score": zod.number().nullish()
})).optional(),
  "overallScore": zod.number().nullish(),
  "overallFeedback": zod.string().nullish(),
  "resumeTitle": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "createdAt": zod.string(),
  "evaluatedAt": zod.string().nullish()
})


/**
 * @summary Atomically create an interview session and queue questions
 */
export const createInterviewTaskHeaderIdempotencyKeyMax = 255;



export const CreateInterviewTaskHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(createInterviewTaskHeaderIdempotencyKeyMax)
})

export const CreateInterviewTaskBody = zod.object({
  "resumeId": zod.number(),
  "companyId": zod.number()
})

export const createInterviewTaskResponseTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const CreateInterviewTaskResponse = zod.object({
  "taskId": zod.string().regex(createInterviewTaskResponseTaskIdRegExp),
  "feature": zod.enum(['resume-review', 'resume-upload', 'career-analysis', 'resume-spellcheck', 'interview-questions', 'interview-evaluation', 'cover-letter-prompts', 'cover-letter-audio', 'company-recommendation', 'job-posting-search', 'job-posting-import']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "subjectType": zod.string().nullable(),
  "subjectId": zod.string().nullable()
})


/**
 * @summary Get interview session with questions and answers
 */
export const GetInterviewParams = zod.object({
  "id": zod.coerce.number()
})

export const GetInterviewResponse = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "resumeId": zod.number(),
  "companyId": zod.number(),
  "status": zod.enum(['pending', 'questions_generated', 'answers_submitted', 'evaluated']),
  "questions": zod.array(zod.object({
  "id": zod.number(),
  "question": zod.string(),
  "order": zod.number(),
  "answer": zod.string().nullish(),
  "feedback": zod.string().nullish(),
  "score": zod.number().nullish()
})).optional(),
  "overallScore": zod.number().nullish(),
  "overallFeedback": zod.string().nullish(),
  "resumeTitle": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "createdAt": zod.string(),
  "evaluatedAt": zod.string().nullish()
})


/**
 * @summary Submit answers to interview questions
 */
export const SubmitAnswersParams = zod.object({
  "id": zod.coerce.number()
})

export const SubmitAnswersBody = zod.object({
  "answers": zod.array(zod.object({
  "questionId": zod.number(),
  "answer": zod.string()
}))
})

export const SubmitAnswersResponse = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "resumeId": zod.number(),
  "companyId": zod.number(),
  "status": zod.enum(['pending', 'questions_generated', 'answers_submitted', 'evaluated']),
  "questions": zod.array(zod.object({
  "id": zod.number(),
  "question": zod.string(),
  "order": zod.number(),
  "answer": zod.string().nullish(),
  "feedback": zod.string().nullish(),
  "score": zod.number().nullish()
})).optional(),
  "overallScore": zod.number().nullish(),
  "overallFeedback": zod.string().nullish(),
  "resumeTitle": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "createdAt": zod.string(),
  "evaluatedAt": zod.string().nullish()
})


/**
 * @summary AI evaluation of interview answers
 */
export const EvaluateAnswersParams = zod.object({
  "id": zod.coerce.number()
})

export const EvaluateAnswersResponse = zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "resumeId": zod.number(),
  "companyId": zod.number(),
  "status": zod.enum(['pending', 'questions_generated', 'answers_submitted', 'evaluated']),
  "questions": zod.array(zod.object({
  "id": zod.number(),
  "question": zod.string(),
  "order": zod.number(),
  "answer": zod.string().nullish(),
  "feedback": zod.string().nullish(),
  "score": zod.number().nullish()
})).optional(),
  "overallScore": zod.number().nullish(),
  "overallFeedback": zod.string().nullish(),
  "resumeTitle": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "createdAt": zod.string(),
  "evaluatedAt": zod.string().nullish()
})


/**
 * @summary Queue evaluation for the current submitted answers
 */



export const CreateInterviewEvaluationTaskParams = zod.object({
  "id": zod.coerce.number().min(1)
})

export const createInterviewEvaluationTaskHeaderIdempotencyKeyMax = 255;



export const CreateInterviewEvaluationTaskHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(createInterviewEvaluationTaskHeaderIdempotencyKeyMax)
})

export const createInterviewEvaluationTaskResponseTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const CreateInterviewEvaluationTaskResponse = zod.object({
  "taskId": zod.string().regex(createInterviewEvaluationTaskResponseTaskIdRegExp),
  "feature": zod.enum(['resume-review', 'resume-upload', 'career-analysis', 'resume-spellcheck', 'interview-questions', 'interview-evaluation', 'cover-letter-prompts', 'cover-letter-audio', 'company-recommendation', 'job-posting-search', 'job-posting-import']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "subjectType": zod.string().nullable(),
  "subjectId": zod.string().nullable()
})


/**
 * @summary Get dashboard summary stats
 */
export const GetDashboardResponse = zod.object({
  "totalResumes": zod.number(),
  "totalCompanies": zod.number(),
  "totalAnalyses": zod.number(),
  "passedAnalyses": zod.number(),
  "failedAnalyses": zod.number(),
  "pendingAnalyses": zod.number(),
  "totalInterviews": zod.number(),
  "averageScore": zod.number().nullable(),
  "recentAnalyses": zod.array(zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "resumeId": zod.number(),
  "companyId": zod.number(),
  "status": zod.enum(['pending', 'processing', 'completed', 'failed']),
  "overallResult": zod.enum(['pass', 'fail', 'null']).nullish(),
  "errorMessage": zod.string().nullish(),
  "overallScore": zod.number().nullish(),
  "aiWritingScore": zod.number().nullish(),
  "aiWritingFeedback": zod.string().nullish(),
  "languageScore": zod.number().nullish(),
  "languageFeedback": zod.string().nullish(),
  "jobMatchScore": zod.number().nullish(),
  "jobMatchFeedback": zod.string().nullish(),
  "improvementSuggestions": zod.string().nullish(),
  "urlAnalysisResult": zod.string().nullish(),
  "richAnalysisResult": zod.string().nullish(),
  "resumeTitle": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "createdAt": zod.string(),
  "completedAt": zod.string().nullish()
})),
  "recentInterviews": zod.array(zod.object({
  "id": zod.number(),
  "userId": zod.number(),
  "resumeId": zod.number(),
  "companyId": zod.number(),
  "status": zod.enum(['pending', 'questions_generated', 'answers_submitted', 'evaluated']),
  "questions": zod.array(zod.object({
  "id": zod.number(),
  "question": zod.string(),
  "order": zod.number(),
  "answer": zod.string().nullish(),
  "feedback": zod.string().nullish(),
  "score": zod.number().nullish()
})).optional(),
  "overallScore": zod.number().nullish(),
  "overallFeedback": zod.string().nullish(),
  "resumeTitle": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "createdAt": zod.string(),
  "evaluatedAt": zod.string().nullish()
}))
})


/**
 * @summary List the authenticated user's AI tasks
 */
export const listAiTasksQueryCursorMax = 1024;

export const listAiTasksQueryLimitDefault = 20;
export const listAiTasksQueryLimitMax = 50;



export const ListAiTasksQueryParams = zod.object({
  "cursor": zod.coerce.string().max(listAiTasksQueryCursorMax).optional(),
  "limit": zod.coerce.number().min(1).max(listAiTasksQueryLimitMax).default(listAiTasksQueryLimitDefault),
  "feature": zod.enum(['resume-review', 'resume-upload', 'career-analysis', 'resume-spellcheck', 'interview-questions', 'interview-evaluation', 'cover-letter-prompts', 'cover-letter-audio', 'company-recommendation', 'job-posting-search', 'job-posting-import']).optional(),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']).optional()
})

export const listAiTasksResponseItemsItemIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');



export const listAiTasksResponseItemsItemTargetOneThreeTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');

export const listAiTasksResponseItemsItemTargetOneFiveTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const listAiTasksResponseItemsItemTargetOneSixTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const listAiTasksResponseItemsItemTargetOneSevenTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');

export const listAiTasksResponseItemsItemTargetOneEightTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const listAiTasksResponseItemsItemErrorCodeMax = 255;

export const listAiTasksResponseItemsItemErrorMessageMax = 2000;

export const listAiTasksResponseNextCursorMax = 1024;



export const ListAiTasksResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().regex(listAiTasksResponseItemsItemIdRegExp),
  "feature": zod.enum(['resume-review', 'resume-upload', 'career-analysis', 'resume-spellcheck', 'interview-questions', 'interview-evaluation', 'cover-letter-prompts', 'cover-letter-audio', 'company-recommendation', 'job-posting-search', 'job-posting-import']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "target": zod.union([zod.union([zod.object({
  "type": zod.enum(['analysis']),
  "analysisId": zod.number().min(1)
}),zod.object({
  "type": zod.enum(['resume-career']),
  "resumeId": zod.number().min(1)
}),zod.object({
  "type": zod.enum(['resume-spellcheck', 'resume-upload']),
  "resumeId": zod.number().min(1),
  "taskId": zod.string().regex(listAiTasksResponseItemsItemTargetOneThreeTaskIdRegExp)
}),zod.object({
  "type": zod.enum(['interview']),
  "interviewId": zod.number().min(1)
}),zod.object({
  "type": zod.enum(['cover-letter']),
  "taskId": zod.string().regex(listAiTasksResponseItemsItemTargetOneFiveTaskIdRegExp)
}),zod.object({
  "type": zod.enum(['companies']),
  "taskId": zod.string().regex(listAiTasksResponseItemsItemTargetOneSixTaskIdRegExp)
}),zod.object({
  "type": zod.enum(['company-draft']),
  "taskId": zod.string().regex(listAiTasksResponseItemsItemTargetOneSevenTaskIdRegExp)
}),zod.object({
  "type": zod.enum(['company']),
  "companyId": zod.number().min(1),
  "taskId": zod.string().regex(listAiTasksResponseItemsItemTargetOneEightTaskIdRegExp)
})]),zod.null()]),
  "createdAt": zod.string().describe('ISO 8601 date-time'),
  "startedAt": zod.string().nullable().describe('ISO 8601 date-time'),
  "completedAt": zod.string().nullable().describe('ISO 8601 date-time'),
  "viewedAt": zod.string().nullable().describe('ISO 8601 date-time'),
  "errorCode": zod.string().min(1).max(listAiTasksResponseItemsItemErrorCodeMax).nullable(),
  "errorMessage": zod.string().max(listAiTasksResponseItemsItemErrorMessageMax).nullable()
})),
  "nextCursor": zod.string().max(listAiTasksResponseNextCursorMax).nullable()
})


/**
 * @summary Get one owned AI task and its validated result projection
 */
export const getAiTaskPathTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const GetAiTaskParams = zod.object({
  "taskId": zod.coerce.string().regex(getAiTaskPathTaskIdRegExp)
})

export const getAiTaskResponseIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');



export const getAiTaskResponseTargetOneThreeTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');

export const getAiTaskResponseTargetOneFiveTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const getAiTaskResponseTargetOneSixTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const getAiTaskResponseTargetOneSevenTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');

export const getAiTaskResponseTargetOneEightTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const getAiTaskResponseErrorCodeMax = 255;

export const getAiTaskResponseErrorMessageMax = 2000;




export const getAiTaskResponseResultOneThreeResultResumeRevisionMax = 255;

export const getAiTaskResponseResultOneThreeResultResumeRevisionIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const getAiTaskResponseResultOneThreeResultAnalysisStrengthsItemTitleMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisStrengthsItemEvidenceMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisStrengthsMax = 5;

export const getAiTaskResponseResultOneThreeResultAnalysisNcsCategoriesItemMajorMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisNcsCategoriesItemMiddleMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisNcsCategoriesItemLevelMin = 0;
export const getAiTaskResponseResultOneThreeResultAnalysisNcsCategoriesItemLevelMax = 8;

export const getAiTaskResponseResultOneThreeResultAnalysisNcsCategoriesItemFitReasonMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisNcsCategoriesMax = 3;

export const getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemJobMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemNcsCategoryMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemFitScoreMin = 0;
export const getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemFitScoreMax = 100;

export const getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemReasonMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemOutlookMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemOutlookScoreMin = 0;
export const getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemOutlookScoreMax = 100;

export const getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemSalaryGuideMinMin = 0;
export const getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemSalaryGuideMinMax = 100000;

export const getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemSalaryGuideMaxMin = 0;
export const getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemSalaryGuideMaxMax = 100000;

export const getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemSalaryGuideBasisMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsMax = 3;

export const getAiTaskResponseResultOneThreeResultAnalysisSummaryMax = 20000;

export const getAiTaskResponseResultOneThreeResultAnalysisResumeSummaryMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisSalaryGuideMinMin = 0;
export const getAiTaskResponseResultOneThreeResultAnalysisSalaryGuideMinMax = 100000;

export const getAiTaskResponseResultOneThreeResultAnalysisSalaryGuideMaxMin = 0;
export const getAiTaskResponseResultOneThreeResultAnalysisSalaryGuideMaxMax = 100000;

export const getAiTaskResponseResultOneThreeResultAnalysisSalaryGuideBasisMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisTypoIssuesItemFoundMax = 300;

export const getAiTaskResponseResultOneThreeResultAnalysisTypoIssuesItemSuggestionMax = 300;

export const getAiTaskResponseResultOneThreeResultAnalysisTypoIssuesItemNoteMax = 300;

export const getAiTaskResponseResultOneThreeResultAnalysisTypoIssuesMax = 10;

export const getAiTaskResponseResultOneThreeResultAnalysisDateIssuesItemFoundMax = 300;

export const getAiTaskResponseResultOneThreeResultAnalysisDateIssuesItemIssueMax = 300;

export const getAiTaskResponseResultOneThreeResultAnalysisDateIssuesItemSuggestionMax = 300;

export const getAiTaskResponseResultOneThreeResultAnalysisDateIssuesMax = 10;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemTitleMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemAuthorsItemMax = 300;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemAuthorsMax = 30;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemApplicantAuthorOrderMin = 0;
export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemApplicantAuthorOrderMax = 30;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemVenueMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemAbstractMax = 5000;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemIssuesItemMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemIssuesMax = 10;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationRecordsItemTitleMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationRecordsItemAuthorsItemMax = 300;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationRecordsItemAuthorsMax = 30;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationRecordsItemVenueMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationRecordsItemDoiMax = 500;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationRecordsItemUrlMax = 2048;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationRecordsMax = 3;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationConflictsItemMax = 1000;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationConflictsMax = 10;

export const getAiTaskResponseResultOneThreeResultAnalysisPapersMax = 10;


export const getAiTaskResponseResultOneFourResultQuestionCountMin = 0;
export const getAiTaskResponseResultOneFourResultQuestionCountMax = 100;


export const getAiTaskResponseResultOneFiveResultScoreMin = 0;
export const getAiTaskResponseResultOneFiveResultScoreMax = 100;


export const getAiTaskResponseResultOneSixResultResumeRevisionMax = 255;

export const getAiTaskResponseResultOneSixResultResumeRevisionIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const getAiTaskResponseResultOneSixResultPromptsItemMax = 5000;

export const getAiTaskResponseResultOneSixResultPromptsMax = 20;

export const getAiTaskResponseResultOneSevenResultTranscriptMax = 500000;

export const getAiTaskResponseResultOneSevenResultCoverLetterMax = 500000;



export const getAiTaskResponseResultOneEightResultCompanyIdsMax = 1000;


export const getAiTaskResponseResultOneEightResultRecommendationsItemNameMax = 255;

export const getAiTaskResponseResultOneEightResultRecommendationsItemRationaleMax = 5000;

export const getAiTaskResponseResultOneEightResultRecommendationsMax = 1000;

export const getAiTaskResponseResultOneNineResultSearchIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const getAiTaskResponseResultOneNineResultBatchIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const getAiTaskResponseResultOneNineResultVersionMin = 0;

export const getAiTaskResponseResultOneNineResultProviderStatusItemFetchedPagesMin = 0;

export const getAiTaskResponseResultOneNineResultProviderStatusItemPendingMin = 0;

export const getAiTaskResponseResultOneNineResultProviderStatusMax = 3;

export const getAiTaskResponseResultOneNineResultRetryAfterMsMin = 0;

export const getAiTaskResponseResultOneNineResultWarningsItemMax = 500;

export const getAiTaskResponseResultOneNineResultWarningsMax = 50;

export const getAiTaskResponseResultOneNineResultPostingsItemCandidateKeyMax = 512;

export const getAiTaskResponseResultOneNineResultPostingsItemExternalIdMax = 255;

export const getAiTaskResponseResultOneNineResultPostingsItemTitleMax = 500;

export const getAiTaskResponseResultOneNineResultPostingsItemCompanyNameMax = 255;

export const getAiTaskResponseResultOneNineResultPostingsItemUrlMax = 2048;

export const getAiTaskResponseResultOneNineResultPostingsItemLocationTextMax = 500;

export const getAiTaskResponseResultOneNineResultPostingsItemCareerTextMax = 500;

export const getAiTaskResponseResultOneNineResultPostingsItemEducationTextMax = 500;

export const getAiTaskResponseResultOneNineResultPostingsItemSummaryMax = 10000;

export const getAiTaskResponseResultOneNineResultPostingsItemJobDescriptionMax = 200000;

export const getAiTaskResponseResultOneNineResultPostingsItemFetchedAtMax = 255;

export const getAiTaskResponseResultOneNineResultPostingsMax = 2000;


export const getAiTaskResponseResultOneOnezeroResultResumeRevisionMax = 255;

export const getAiTaskResponseResultOneOnezeroResultResumeRevisionIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const getAiTaskResponseResultOneOnezeroResultCorrectionsItemOriginalMax = 10000;

export const getAiTaskResponseResultOneOnezeroResultCorrectionsItemCorrectedMax = 10000;

export const getAiTaskResponseResultOneOnezeroResultCorrectionsItemReasonMax = 1000;

export const getAiTaskResponseResultOneOnezeroResultCorrectionsMax = 10000;

export const getAiTaskResponseResultOneOnezeroResultContentCorrectedMax = 500000;

export const getAiTaskResponseResultOneOnezeroResultCoverLetterCorrectedMax = 500000;


export const getAiTaskResponseResultOneOneoneResultTitleMax = 500;

export const getAiTaskResponseResultOneOneoneResultTextMax = 1000000;

export const getAiTaskResponseResultOneOneoneResultNormalizedUrlMax = 2048;



export const GetAiTaskResponse = zod.object({
  "id": zod.string().regex(getAiTaskResponseIdRegExp),
  "feature": zod.enum(['resume-review', 'resume-upload', 'career-analysis', 'resume-spellcheck', 'interview-questions', 'interview-evaluation', 'cover-letter-prompts', 'cover-letter-audio', 'company-recommendation', 'job-posting-search', 'job-posting-import']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "target": zod.union([zod.union([zod.object({
  "type": zod.enum(['analysis']),
  "analysisId": zod.number().min(1)
}),zod.object({
  "type": zod.enum(['resume-career']),
  "resumeId": zod.number().min(1)
}),zod.object({
  "type": zod.enum(['resume-spellcheck', 'resume-upload']),
  "resumeId": zod.number().min(1),
  "taskId": zod.string().regex(getAiTaskResponseTargetOneThreeTaskIdRegExp)
}),zod.object({
  "type": zod.enum(['interview']),
  "interviewId": zod.number().min(1)
}),zod.object({
  "type": zod.enum(['cover-letter']),
  "taskId": zod.string().regex(getAiTaskResponseTargetOneFiveTaskIdRegExp)
}),zod.object({
  "type": zod.enum(['companies']),
  "taskId": zod.string().regex(getAiTaskResponseTargetOneSixTaskIdRegExp)
}),zod.object({
  "type": zod.enum(['company-draft']),
  "taskId": zod.string().regex(getAiTaskResponseTargetOneSevenTaskIdRegExp)
}),zod.object({
  "type": zod.enum(['company']),
  "companyId": zod.number().min(1),
  "taskId": zod.string().regex(getAiTaskResponseTargetOneEightTaskIdRegExp)
})]),zod.null()]),
  "createdAt": zod.string().describe('ISO 8601 date-time'),
  "startedAt": zod.string().nullable().describe('ISO 8601 date-time'),
  "completedAt": zod.string().nullable().describe('ISO 8601 date-time'),
  "viewedAt": zod.string().nullable().describe('ISO 8601 date-time'),
  "errorCode": zod.string().min(1).max(getAiTaskResponseErrorCodeMax).nullable(),
  "errorMessage": zod.string().max(getAiTaskResponseErrorMessageMax).nullable(),
  "result": zod.union([zod.union([zod.object({
  "feature": zod.enum(['resume-review']),
  "result": zod.object({
  "analysisId": zod.number().min(1)
})
}),zod.object({
  "feature": zod.enum(['resume-upload']),
  "result": zod.object({
  "resumeId": zod.number().min(1)
})
}),zod.object({
  "feature": zod.enum(['career-analysis']),
  "result": zod.object({
  "resumeId": zod.number().min(1),
  "resumeRevision": zod.string().min(1).max(getAiTaskResponseResultOneThreeResultResumeRevisionMax),
  "resumeRevisionId": zod.string().regex(getAiTaskResponseResultOneThreeResultResumeRevisionIdRegExp).optional(),
  "analysis": zod.object({
  "strengths": zod.array(zod.object({
  "title": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisStrengthsItemTitleMax),
  "evidence": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisStrengthsItemEvidenceMax)
})).max(getAiTaskResponseResultOneThreeResultAnalysisStrengthsMax),
  "ncsCategories": zod.array(zod.object({
  "major": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisNcsCategoriesItemMajorMax),
  "middle": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisNcsCategoriesItemMiddleMax),
  "level": zod.number().min(getAiTaskResponseResultOneThreeResultAnalysisNcsCategoriesItemLevelMin).max(getAiTaskResponseResultOneThreeResultAnalysisNcsCategoriesItemLevelMax).nullable(),
  "fitReason": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisNcsCategoriesItemFitReasonMax)
})).max(getAiTaskResponseResultOneThreeResultAnalysisNcsCategoriesMax),
  "recommendedJobs": zod.array(zod.object({
  "job": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemJobMax),
  "ncsCategory": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemNcsCategoryMax),
  "fitScore": zod.number().min(getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemFitScoreMin).max(getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemFitScoreMax).nullable(),
  "reason": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemReasonMax),
  "outlook": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemOutlookMax),
  "outlookScore": zod.number().min(getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemOutlookScoreMin).max(getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemOutlookScoreMax).nullable(),
  "salaryGuide": zod.object({
  "min": zod.number().min(getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemSalaryGuideMinMin).max(getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemSalaryGuideMinMax).nullable(),
  "max": zod.number().min(getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemSalaryGuideMaxMin).max(getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemSalaryGuideMaxMax).nullable(),
  "basis": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsItemSalaryGuideBasisMax)
})
})).max(getAiTaskResponseResultOneThreeResultAnalysisRecommendedJobsMax),
  "summary": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisSummaryMax),
  "resumeSummary": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisResumeSummaryMax),
  "salaryGuide": zod.object({
  "min": zod.number().min(getAiTaskResponseResultOneThreeResultAnalysisSalaryGuideMinMin).max(getAiTaskResponseResultOneThreeResultAnalysisSalaryGuideMinMax).nullable(),
  "max": zod.number().min(getAiTaskResponseResultOneThreeResultAnalysisSalaryGuideMaxMin).max(getAiTaskResponseResultOneThreeResultAnalysisSalaryGuideMaxMax).nullable(),
  "basis": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisSalaryGuideBasisMax)
}),
  "typoIssues": zod.array(zod.object({
  "found": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisTypoIssuesItemFoundMax),
  "suggestion": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisTypoIssuesItemSuggestionMax),
  "note": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisTypoIssuesItemNoteMax)
})).max(getAiTaskResponseResultOneThreeResultAnalysisTypoIssuesMax),
  "dateIssues": zod.array(zod.object({
  "found": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisDateIssuesItemFoundMax),
  "issue": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisDateIssuesItemIssueMax),
  "suggestion": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisDateIssuesItemSuggestionMax)
})).max(getAiTaskResponseResultOneThreeResultAnalysisDateIssuesMax),
  "papers": zod.array(zod.object({
  "title": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisPapersItemTitleMax),
  "authors": zod.array(zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisPapersItemAuthorsItemMax)).max(getAiTaskResponseResultOneThreeResultAnalysisPapersItemAuthorsMax),
  "applicantAuthorOrder": zod.number().min(getAiTaskResponseResultOneThreeResultAnalysisPapersItemApplicantAuthorOrderMin).max(getAiTaskResponseResultOneThreeResultAnalysisPapersItemApplicantAuthorOrderMax).nullable(),
  "venue": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisPapersItemVenueMax),
  "abstract": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisPapersItemAbstractMax),
  "issues": zod.array(zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisPapersItemIssuesItemMax)).max(getAiTaskResponseResultOneThreeResultAnalysisPapersItemIssuesMax),
  "verification": zod.object({
  "status": zod.enum(['verified', 'unverified', 'conflict']),
  "records": zod.array(zod.object({
  "source": zod.enum(['Crossref', 'OpenAlex', 'KCI']),
  "title": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationRecordsItemTitleMax),
  "authors": zod.array(zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationRecordsItemAuthorsItemMax)).max(getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationRecordsItemAuthorsMax),
  "venue": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationRecordsItemVenueMax),
  "doi": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationRecordsItemDoiMax),
  "url": zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationRecordsItemUrlMax)
})).max(getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationRecordsMax),
  "conflicts": zod.array(zod.string().max(getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationConflictsItemMax)).max(getAiTaskResponseResultOneThreeResultAnalysisPapersItemVerificationConflictsMax)
})
})).max(getAiTaskResponseResultOneThreeResultAnalysisPapersMax)
}).optional()
})
}),zod.object({
  "feature": zod.enum(['interview-questions']),
  "result": zod.object({
  "interviewId": zod.number().min(1),
  "questionCount": zod.number().min(getAiTaskResponseResultOneFourResultQuestionCountMin).max(getAiTaskResponseResultOneFourResultQuestionCountMax)
})
}),zod.object({
  "feature": zod.enum(['interview-evaluation']),
  "result": zod.object({
  "interviewId": zod.number().min(1),
  "score": zod.number().min(getAiTaskResponseResultOneFiveResultScoreMin).max(getAiTaskResponseResultOneFiveResultScoreMax).nullable()
})
}),zod.object({
  "feature": zod.enum(['cover-letter-prompts']),
  "result": zod.object({
  "resumeId": zod.number().min(1),
  "resumeRevision": zod.string().min(1).max(getAiTaskResponseResultOneSixResultResumeRevisionMax),
  "resumeRevisionId": zod.string().regex(getAiTaskResponseResultOneSixResultResumeRevisionIdRegExp).optional(),
  "prompts": zod.array(zod.string().min(1).max(getAiTaskResponseResultOneSixResultPromptsItemMax)).min(1).max(getAiTaskResponseResultOneSixResultPromptsMax),
  "usedFallback": zod.boolean()
})
}),zod.object({
  "feature": zod.enum(['cover-letter-audio']),
  "result": zod.object({
  "transcript": zod.string().max(getAiTaskResponseResultOneSevenResultTranscriptMax),
  "coverLetter": zod.string().max(getAiTaskResponseResultOneSevenResultCoverLetterMax),
  "resumeId": zod.number().min(1).nullable()
})
}),zod.object({
  "feature": zod.enum(['company-recommendation']),
  "result": zod.object({
  "companyIds": zod.array(zod.number().min(1)).min(1).max(getAiTaskResponseResultOneEightResultCompanyIdsMax),
  "recommendations": zod.array(zod.object({
  "companyId": zod.number().min(1),
  "name": zod.string().min(1).max(getAiTaskResponseResultOneEightResultRecommendationsItemNameMax),
  "rationale": zod.string().max(getAiTaskResponseResultOneEightResultRecommendationsItemRationaleMax)
})).max(getAiTaskResponseResultOneEightResultRecommendationsMax)
})
}),zod.object({
  "feature": zod.enum(['job-posting-search']),
  "result": zod.object({
  "searchId": zod.string().regex(getAiTaskResponseResultOneNineResultSearchIdRegExp),
  "batchId": zod.string().regex(getAiTaskResponseResultOneNineResultBatchIdRegExp),
  "version": zod.number().min(getAiTaskResponseResultOneNineResultVersionMin),
  "blocked": zod.boolean(),
  "providerStatus": zod.array(zod.object({
  "provider": zod.enum(['saramin', 'jobkorea', 'wanted']),
  "exhausted": zod.boolean(),
  "failure": zod.union([zod.enum(['blocked', 'rate_limited', 'timeout', 'upstream_error', 'parse_error', 'unsupported_filters', 'not_configured']),zod.null()]),
  "retryAt": zod.union([zod.coerce.date(),zod.null()]),
  "fetchedPages": zod.number().min(getAiTaskResponseResultOneNineResultProviderStatusItemFetchedPagesMin),
  "pending": zod.number().min(getAiTaskResponseResultOneNineResultProviderStatusItemPendingMin)
})).max(getAiTaskResponseResultOneNineResultProviderStatusMax),
  "completion": zod.enum(['more', 'exhausted', 'interrupted']),
  "isLast": zod.boolean(),
  "retryAfterMs": zod.number().min(getAiTaskResponseResultOneNineResultRetryAfterMsMin).nullable(),
  "warnings": zod.array(zod.string().max(getAiTaskResponseResultOneNineResultWarningsItemMax)).max(getAiTaskResponseResultOneNineResultWarningsMax),
  "postings": zod.array(zod.object({
  "candidateKey": zod.string().min(1).max(getAiTaskResponseResultOneNineResultPostingsItemCandidateKeyMax),
  "externalId": zod.string().min(1).max(getAiTaskResponseResultOneNineResultPostingsItemExternalIdMax),
  "title": zod.string().min(1).max(getAiTaskResponseResultOneNineResultPostingsItemTitleMax),
  "companyName": zod.string().min(1).max(getAiTaskResponseResultOneNineResultPostingsItemCompanyNameMax),
  "url": zod.string().max(getAiTaskResponseResultOneNineResultPostingsItemUrlMax),
  "imported": zod.boolean(),
  "locationText": zod.string().max(getAiTaskResponseResultOneNineResultPostingsItemLocationTextMax).nullable(),
  "careerText": zod.string().max(getAiTaskResponseResultOneNineResultPostingsItemCareerTextMax).nullable(),
  "educationText": zod.string().max(getAiTaskResponseResultOneNineResultPostingsItemEducationTextMax).nullable(),
  "summary": zod.string().max(getAiTaskResponseResultOneNineResultPostingsItemSummaryMax).nullable(),
  "jobDescription": zod.string().max(getAiTaskResponseResultOneNineResultPostingsItemJobDescriptionMax).nullable(),
  "fetchedAt": zod.string().min(1).max(getAiTaskResponseResultOneNineResultPostingsItemFetchedAtMax),
  "detailStatus": zod.enum(['not_requested', 'ok', 'blocked', 'unavailable', 'empty'])
})).max(getAiTaskResponseResultOneNineResultPostingsMax)
})
}),zod.object({
  "feature": zod.enum(['resume-spellcheck']),
  "result": zod.object({
  "resumeId": zod.number().min(1),
  "resumeRevision": zod.string().min(1).max(getAiTaskResponseResultOneOnezeroResultResumeRevisionMax),
  "resumeRevisionId": zod.string().regex(getAiTaskResponseResultOneOnezeroResultResumeRevisionIdRegExp).optional(),
  "corrections": zod.array(zod.object({
  "field": zod.enum(['content', 'coverLetter']),
  "original": zod.string().max(getAiTaskResponseResultOneOnezeroResultCorrectionsItemOriginalMax),
  "corrected": zod.string().max(getAiTaskResponseResultOneOnezeroResultCorrectionsItemCorrectedMax),
  "reason": zod.string().max(getAiTaskResponseResultOneOnezeroResultCorrectionsItemReasonMax)
})).max(getAiTaskResponseResultOneOnezeroResultCorrectionsMax),
  "contentCorrected": zod.string().max(getAiTaskResponseResultOneOnezeroResultContentCorrectedMax),
  "coverLetterCorrected": zod.string().max(getAiTaskResponseResultOneOnezeroResultCoverLetterCorrectedMax)
})
}),zod.object({
  "feature": zod.enum(['job-posting-import']),
  "result": zod.object({
  "companyId": zod.number().min(1).nullable(),
  "title": zod.string().max(getAiTaskResponseResultOneOneoneResultTitleMax),
  "text": zod.string().max(getAiTaskResponseResultOneOneoneResultTextMax),
  "source": zod.enum(['html', 'ocr']),
  "normalizedUrl": zod.string().max(getAiTaskResponseResultOneOneoneResultNormalizedUrlMax)
})
})]),zod.null()])
})


/**
 * @summary Mark a terminal AI task as viewed
 */
export const markAiTaskViewedPathTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const MarkAiTaskViewedParams = zod.object({
  "taskId": zod.coerce.string().regex(markAiTaskViewedPathTaskIdRegExp)
})

export const markAiTaskViewedResponseIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const MarkAiTaskViewedResponse = zod.object({
  "id": zod.string().regex(markAiTaskViewedResponseIdRegExp),
  "viewedAt": zod.string().describe('ISO 8601 date-time')
})


/**
 * @summary List the authenticated user's notifications
 */
export const listNotificationsQueryCursorMax = 1024;

export const listNotificationsQueryLimitDefault = 20;
export const listNotificationsQueryLimitMax = 100;



export const ListNotificationsQueryParams = zod.object({
  "cursor": zod.coerce.string().max(listNotificationsQueryCursorMax).optional(),
  "limit": zod.coerce.number().min(1).max(listNotificationsQueryLimitMax).default(listNotificationsQueryLimitDefault)
})

export const listNotificationsResponseItemsItemIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const listNotificationsResponseItemsItemTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const listNotificationsResponseItemsItemTitleMax = 120;

export const listNotificationsResponseItemsItemMessageMax = 500;




export const listNotificationsResponseItemsItemTargetOneThreeTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');

export const listNotificationsResponseItemsItemTargetOneFiveTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const listNotificationsResponseItemsItemTargetOneSixTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const listNotificationsResponseItemsItemTargetOneSevenTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');

export const listNotificationsResponseItemsItemTargetOneEightTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const listNotificationsResponseNextCursorMax = 1024;

export const listNotificationsResponseUnreadCountMin = 0;



export const ListNotificationsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().regex(listNotificationsResponseItemsItemIdRegExp),
  "taskId": zod.string().regex(listNotificationsResponseItemsItemTaskIdRegExp),
  "kind": zod.enum(['ai-task-succeeded', 'ai-task-failed']),
  "title": zod.string().min(1).max(listNotificationsResponseItemsItemTitleMax),
  "message": zod.string().min(1).max(listNotificationsResponseItemsItemMessageMax),
  "target": zod.union([zod.union([zod.object({
  "type": zod.enum(['analysis']),
  "analysisId": zod.number().min(1)
}),zod.object({
  "type": zod.enum(['resume-career']),
  "resumeId": zod.number().min(1)
}),zod.object({
  "type": zod.enum(['resume-spellcheck', 'resume-upload']),
  "resumeId": zod.number().min(1),
  "taskId": zod.string().regex(listNotificationsResponseItemsItemTargetOneThreeTaskIdRegExp)
}),zod.object({
  "type": zod.enum(['interview']),
  "interviewId": zod.number().min(1)
}),zod.object({
  "type": zod.enum(['cover-letter']),
  "taskId": zod.string().regex(listNotificationsResponseItemsItemTargetOneFiveTaskIdRegExp)
}),zod.object({
  "type": zod.enum(['companies']),
  "taskId": zod.string().regex(listNotificationsResponseItemsItemTargetOneSixTaskIdRegExp)
}),zod.object({
  "type": zod.enum(['company-draft']),
  "taskId": zod.string().regex(listNotificationsResponseItemsItemTargetOneSevenTaskIdRegExp)
}),zod.object({
  "type": zod.enum(['company']),
  "companyId": zod.number().min(1),
  "taskId": zod.string().regex(listNotificationsResponseItemsItemTargetOneEightTaskIdRegExp)
})]),zod.null()]),
  "createdAt": zod.coerce.date(),
  "toastPresentedAt": zod.coerce.date().nullable(),
  "readAt": zod.coerce.date().nullable()
})),
  "nextCursor": zod.string().max(listNotificationsResponseNextCursorMax).nullable(),
  "unreadCount": zod.number().min(listNotificationsResponseUnreadCountMin),
  "serverTime": zod.coerce.date()
})


/**
 * @summary Atomically claim eligible unread notification toasts
 */
export const claimNotificationToastsBodyLimitMax = 20;



export const ClaimNotificationToastsBody = zod.object({
  "limit": zod.number().min(1).max(claimNotificationToastsBodyLimitMax),
  "eligibleAfter": zod.coerce.date()
})

export const claimNotificationToastsResponseItemsItemIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const claimNotificationToastsResponseItemsItemTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const claimNotificationToastsResponseItemsItemTitleMax = 120;

export const claimNotificationToastsResponseItemsItemMessageMax = 500;




export const claimNotificationToastsResponseItemsItemTargetOneThreeTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');

export const claimNotificationToastsResponseItemsItemTargetOneFiveTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const claimNotificationToastsResponseItemsItemTargetOneSixTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');
export const claimNotificationToastsResponseItemsItemTargetOneSevenTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');

export const claimNotificationToastsResponseItemsItemTargetOneEightTaskIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const ClaimNotificationToastsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().regex(claimNotificationToastsResponseItemsItemIdRegExp),
  "taskId": zod.string().regex(claimNotificationToastsResponseItemsItemTaskIdRegExp),
  "kind": zod.enum(['ai-task-succeeded', 'ai-task-failed']),
  "title": zod.string().min(1).max(claimNotificationToastsResponseItemsItemTitleMax),
  "message": zod.string().min(1).max(claimNotificationToastsResponseItemsItemMessageMax),
  "target": zod.union([zod.union([zod.object({
  "type": zod.enum(['analysis']),
  "analysisId": zod.number().min(1)
}),zod.object({
  "type": zod.enum(['resume-career']),
  "resumeId": zod.number().min(1)
}),zod.object({
  "type": zod.enum(['resume-spellcheck', 'resume-upload']),
  "resumeId": zod.number().min(1),
  "taskId": zod.string().regex(claimNotificationToastsResponseItemsItemTargetOneThreeTaskIdRegExp)
}),zod.object({
  "type": zod.enum(['interview']),
  "interviewId": zod.number().min(1)
}),zod.object({
  "type": zod.enum(['cover-letter']),
  "taskId": zod.string().regex(claimNotificationToastsResponseItemsItemTargetOneFiveTaskIdRegExp)
}),zod.object({
  "type": zod.enum(['companies']),
  "taskId": zod.string().regex(claimNotificationToastsResponseItemsItemTargetOneSixTaskIdRegExp)
}),zod.object({
  "type": zod.enum(['company-draft']),
  "taskId": zod.string().regex(claimNotificationToastsResponseItemsItemTargetOneSevenTaskIdRegExp)
}),zod.object({
  "type": zod.enum(['company']),
  "companyId": zod.number().min(1),
  "taskId": zod.string().regex(claimNotificationToastsResponseItemsItemTargetOneEightTaskIdRegExp)
})]),zod.null()]),
  "createdAt": zod.coerce.date(),
  "toastPresentedAt": zod.coerce.date().nullable(),
  "readAt": zod.coerce.date().nullable()
})),
  "claimedAt": zod.coerce.date()
})


/**
 * @summary Stream authenticated notification snapshots
 */
export const StreamNotificationsResponse = zod.unknown()


/**
 * @summary Mark one owned notification as read
 */
export const markNotificationReadPathNotificationIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const MarkNotificationReadParams = zod.object({
  "notificationId": zod.coerce.string().regex(markNotificationReadPathNotificationIdRegExp)
})

export const markNotificationReadResponseIdRegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$');


export const MarkNotificationReadResponse = zod.object({
  "id": zod.string().regex(markNotificationReadResponseIdRegExp),
  "readAt": zod.coerce.date()
})


/**
 * @summary Mark all owned unread notifications as read
 */
export const markAllNotificationsReadResponseUpdatedCountMin = 0;



export const MarkAllNotificationsReadResponse = zod.object({
  "readAt": zod.coerce.date(),
  "updatedCount": zod.number().min(markAllNotificationsReadResponseUpdatedCountMin)
})


